<template>
  <div class="slide-items">
     <div class="row">
        <div class="col-sm-12" v-for="items in data" :key="items">
          <div class="row">
            <div class="col-sm-8"><h5 class="title-slide-items" @mouseover="accebility(items.category)" v-bind:style="slideitemAccebility(isAccebility)"><img class="image-title" v-bind:src="require('@/assets/icon/icon-title.png')"/>{{ titleCategory(items.category) }}</h5></div>
            <div class="col-sm-4" align="right">
              <div class="row">
                <div class="col-sm-7 filter">
                  <!-- <select class="form-select" v-model="orderSort" @change="sortData()" @mouseover="accebility('Sorting Waktu')">
                    <option value="desc">Waktu Terbaru</option>
                    <option value="asc">Waktu Terlampau</option>
                  </select> -->
                </div>
                <a class="col-sm-5 lihat-selengkapnya" :href="selengkapnya(pageName, items.category)">Lihat Selengkapnya...</a>
              </div>
            </div>
            <div class="col-sm-12">
              <Carousel v-bind="settings" :autoplay="4000" :breakpoints="breakpoints">
              <!-- <Carousel v-bind="settings" :breakpoints="breakpoints"> -->
                  <Slide v-for="slide in items.data" :key="slide">
                    <div class="carousel__item">
                        <a class="card cards-hover d-flex" :title="slide.title" @mouseover="accebility(slide.title)" :href="lihat(slide)">
                          <img v-bind:src="imagesItem(slide)" class="card-img-top">
                          <div class="card-body" align="left">
                              <span class="tag-page">Statistik</span>
                              <span class="tag-category">{{ slide.category }}</span>
                              <h5 class="card-title">{{ limitTitle(slide.title, 20) }}</h5>
                          </div>
                        </a>
                    </div>
                  </Slide>
                  <template #addons>
                    <Navigation />
                  </template>
              </Carousel>
            </div>
          </div>           
        </div>
     </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import { Carousel, Navigation, Slide } from 'vue3-carousel'
  import 'vue3-carousel/dist/carousel.css'
  export default {
    name: 'SlideitemComponents',
    components: {
      Carousel,
      Slide,
      Navigation
    },
    data(){
      return{
        baseUrl:this.$store.state.baseUrl,
        baseApi:this.$store.state.apiUrl,
        paramsData: [],
        pageName:this.$route.meta.page,
        data:[],
        orderSort:'desc',
        settings: {
          itemsToShow: 2,
          snapAlign: 'center',
        },
        breakpoints: {
          400: {
            itemsToShow: 2,
            snapAlign: 'center',
          },
          700: {
            itemsToShow: 3.5,
            snapAlign: 'center',
          },
          1024: {
            itemsToShow: 4,
            snapAlign: 'start',
          },
          1366: {
            itemsToShow: 6,
            snapAlign: 'start',
          },
        },
        isAccebility:this.$store.state.isAccebility
      }
    },
    mounted(){
      this.paramsData = {
        "page":this.$route.meta.page
      }
  
      axios.post(`${this.baseApi}/api/v2/satudata/slide-items`, this.paramsData).then(res=>{
        this.data = res.data
      })
  
    },
    methods:{
      titleCategory(title){
        switch(title){
          case "analisis":
            return "JAKARTA SURVEI (JAKSURVEI)"
          case "artikel":
            return "ARTIKEL"
          case "infografis":
            return "INFOGRAFIS"
          case "produk-statistik":
            return "PRODUK STATISTIK"
          case "dashboard-analytics":
            return "DASHBOARD ANALYTICS"
          case "peta":
            return "PETA JAKARTA"
          case "rubrik-statistik":
            return "RUBRIK STATISITK"
        }
      },
      slideitemAccebility(isAccebility){
        if(isAccebility.modeMalam){
          return{
            color: 'white'
          }
        } else {
            return{
              color: '#052158'
          }
        }
      },
      imagesItem(items){
        if(items.category == 'dataset'){
          if(items.topik_uid == null || items.topik_uid==''){
                return this.baseApi+items.path_cover
            }else{
                return this.baseApi+'/uploads/img/topik/'+items.topik_uid.split(',')[0]+'.jpg'
            } 
        } else {
          return this.baseApi+'/uploads/img/300/'+items.path_cover
        }
      },
      limitTitle (string = '', limit = 0) {
        if(string){
          let next = ''
          if(string.length>limit){
            next = ' ...'
          }
          return string.substring(0, limit) + next
        }
      },
      lihat(items){
        return this.baseUrl + "/"+this.$route.meta.page+"/detail?kategori="+items.category+"&page_url="+items.page_url
      },
      accebility(voice){
        if(this.isAccebility.modeSuara){
          let msg = new SpeechSynthesisUtterance();
          let voices = window.speechSynthesis.getVoices()
          msg.voice = voices[160];
          msg.text = voice;
          msg.volume = 10;
          msg.rate = 1;
          msg.pitch = 1;
          window.speechSynthesis.cancel();
          window.speechSynthesis.speak(msg);
        }
      },
      sortData(){
        this.paramsData = {
          "page":this.$route.meta.page,
          "sort":this.orderSort
        }
    
        axios.post(`${this.baseApi}/api/v2/satudata/slide-items`, this.paramsData).then(res=>{
          this.data = res.data
        })
      },
      selengkapnya(page, category){
        return this.baseUrl + "/search?q=&halaman="+page+"&kategori="+category+"&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
      }
    }
  }
</script>